import * as React from 'react';

const useOnResize = (callback: () => void, isInUse = true): void => {
  React.useEffect(() => {
    if (!isInUse) {
      return;
    }
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, [callback, isInUse]);
};

export default useOnResize;
